import { ViewManyImagesDialog } from "./view.ManyImagesPopUp";

export function ManyImagesDialog (dialogOpen, setDialogOpen) {
    const handleClose = () => {
        setDialogOpen(false);
    };
    return ViewManyImagesDialog(handleClose, dialogOpen)
}